import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div
      className="fixed inset-0 bg-cover bg-top bg-no-repeat"
      style={{ backgroundImage: "url('/NotFound_Page.webp')" }}
    >
      {/* Subtle dark overlay so the button stays readable */}
      <div className="absolute inset-0 bg-black/30" />

      {/* Centred button */}
      <div className="relative z-10 flex h-full w-full items-end justify-center pb-16 sm:pb-24">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 rounded-full bg-white/90 px-8 py-3 text-base font-semibold text-gray-900 shadow-lg backdrop-blur-sm transition hover:bg-white hover:shadow-xl active:scale-95"
        >
          <Home className="h-5 w-5" />
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
